import { defineCustomElements } from '@gov-design-system-ce/components/loader';
export const ComponentLibrary = {
    async install() {
        if (typeof window !== 'undefined') {
            // @stencil/vue-output-target does not support camelCase event names,
            // so we are attaching a custom event listener to map camelCase to kebab-case event names
            const camelCaseToKebab = (str) => {
                return str
                    .split(/(?=[A-Z])/)
                    .join('-')
                    .toLowerCase();
            };
            await defineCustomElements(window, {
                ael: (el, eventName, cb, opts) => el.addEventListener(camelCaseToKebab(eventName), cb, opts),
                rel: (el, eventName, cb, opts) => el.removeEventListener(camelCaseToKebab(eventName), cb, opts),
                ce: (eventName, opts) => new CustomEvent(camelCaseToKebab(eventName), opts),
            });
        }
    },
};
//# sourceMappingURL=plugin.js.map